module.exports = __webpack_public_path__ + "img/slujba-sf-andrei-1726-pagina-de-titlu-big.8c196dbe.jpg";